import React from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false
        }
    }
});

interface Props {
    children: React.ReactNode;
}

export const CustomQueryClientProvider = ({children}: Props) => {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
